import {keyframes} from "@mui/system";
import {ReactNode} from "react";
import {Container} from "../components/Container";
import {colors, layout, radii, spacing} from "../theme";
import {Button} from "../components/Button";
import {Text} from "../components/Text";

const slideUp = keyframes`
  from { transform: translateY(100%); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
`;

export type DrawerConfig = {
  header?: ReactNode;
  ctaLabel: string;
  ctaEndIcon?: ReactNode;
  subtitle?: string;
  onCtaClick?: () => void;
  loading?: boolean;
  disabled?: boolean;
  animate?: boolean;
  customCta?: ReactNode;
};

export const Drawer = ({
  header,
  ctaLabel,
  ctaEndIcon,
  subtitle,
  onCtaClick,
  loading,
  disabled,
  animate,
  customCta,
}: DrawerConfig) => (
  <Container
    center
    sx={{
      backgroundColor: colors.white,
      border: `1px solid ${colors.tertiary[300]}`,
      borderTopLeftRadius: radii.base,
      borderTopRightRadius: radii.base,
      ...(animate && {animation: `${slideUp} 0.4s cubic-bezier(0.4, 0, 0.2, 1)`}),
      boxShadow: "0 -10px 30px rgba(0,0,0,0.08)",
      padding: `${spacing[2]} ${spacing[4]}`,
    }}
  >
    <Container gap={2} fullWidth sx={{maxWidth: layout.maxWidth}}>
      {header}
      {customCta || (
        <Button fullWidth onClick={onCtaClick} endIcon={ctaEndIcon} loading={loading} disabled={disabled}>
          {ctaLabel}
        </Button>
      )}

      {subtitle && (
        <Text variant="caption-medium" color={colors.grey[600]} sx={{textAlign: "center"}}>
          {subtitle}
        </Text>
      )}
    </Container>
  </Container>
);
